var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#E1E1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3111 21.25C15.3111 18.6612 17.4097 16.5625 19.9986 16.5625C22.5874 16.5625 24.6861 18.6612 24.6861 21.25C24.6861 23.8388 22.5874 25.9375 19.9986 25.9375C17.4097 25.9375 15.3111 23.8388 15.3111 21.25ZM19.9986 18.4375C18.4453 18.4375 17.1861 19.6967 17.1861 21.25C17.1861 22.8033 18.4453 24.0625 19.9986 24.0625C21.5519 24.0625 22.8111 22.8033 22.8111 21.25C22.8111 19.6967 21.5519 18.4375 19.9986 18.4375Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2687 12.1875C16.9623 12.1875 15.9032 13.2466 15.9032 14.5531C15.9032 15.3855 15.2642 16.0785 14.4344 16.1459L11.6474 16.3723C11.1002 16.4167 10.6502 16.8214 10.548 17.3608C9.98712 20.3233 9.94529 23.3608 10.4244 26.3376L10.546 27.0928C10.6608 27.8061 11.2478 28.3487 11.9679 28.4072L14.3958 28.6044C18.1249 28.9072 21.8723 28.9072 25.6013 28.6044L28.0292 28.4072C28.7493 28.3487 29.3363 27.8061 29.4512 27.0928L29.5727 26.3376C30.0519 23.3608 30.01 20.3233 29.4491 17.3608C29.347 16.8214 28.8969 16.4167 28.3497 16.3723L25.5627 16.1459C24.733 16.0785 24.094 15.3855 24.094 14.5531C24.094 13.2466 23.0349 12.1875 21.7284 12.1875H18.2687ZM14.0358 14.2971C14.1681 12.0743 16.0127 10.3125 18.2687 10.3125H21.7284C23.9845 10.3125 25.8291 12.0743 25.9614 14.2971L28.5015 14.5034C29.8901 14.6162 31.0322 15.6431 31.2914 17.012C31.8927 20.1879 31.9376 23.4442 31.4239 26.6355L31.3023 27.3908C31.0503 28.9565 29.7617 30.1477 28.181 30.2761L25.7531 30.4732C21.9231 30.7843 18.0741 30.7843 14.2441 30.4732L11.8161 30.2761C10.2355 30.1477 8.94684 28.9565 8.69483 27.3908L8.57327 26.6355C8.0596 23.4442 8.10444 20.1879 8.70578 17.012C8.96497 15.6431 10.107 14.6162 11.4957 14.5034L14.0358 14.2971Z",
    fill: "#161616"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.20a846eb2ae487d438613c05e1681f1b.svg";
export { ForwardRef as ReactComponent };